import React from 'react';
import { RouteComponentProps, useLocation } from '@gatsbyjs/reach-router';
import DHRouter from '~/components/atom/DHRouter';
import { withOverlay } from '~/components/organism/ModalsV2/Overlay';
import StepList from '~/components/organism/StepList';
import WizardLayout from '~/components/molecule/WizardLayout';
import ActivationPendingStep from './components/ActivationPendingStep';
import SetupStep from './components/SetupStep';
import ImportContactsStep from './components/ImportContactsStep';
// import ExportContactsStep from './components/ExportContactsStep';
import pathnameToStep from '~/util/pathnameToStep';
// import { wonenHeader } from '~/components/organism/WizardSteps/Apps/Realworks/RealworksExportContacts';
import { relatieHeader } from '~/components/organism/WizardSteps/Apps/Realworks/RealworksImportContacts';
import { agendaHeader } from '~/components/organism/WizardSteps/Apps/Realworks/RealworksAgenda';
import ImportAgendaStep from './components/ImportAgendaStep';

export type Props = {
  /**  Provided by withOverlay HOC */
  onClose?: () => void;
  refreshAppStatus: () => void;
  /** The offices that are selected in other token container in the app */
  usedOffices: Record<string, string>;
} & RouteComponentProps;

export const LINK_PREFIX = '/-/apps/realworks/wizard';

const AddTokenContainerWizard: React.FCC<Props> = ({
  onClose,
  refreshAppStatus,
  usedOffices,
}) => {
  const location = useLocation();

  const steps = [
    {
      id: 'setup',
      label: 'Instellingen',
      disabled: false,
    },
    {
      id: 'import-contacts',
      label: relatieHeader,
      disabled: false,
    },
    {
      id: 'import-agenda',
      label: agendaHeader,
      disabled: false,
    },
    // {
    //   id: 'export-contacts',
    //   label: wonenHeader,
    //   disabled: false,
    // },
    {
      id: 'activation-pending',
      label: 'Activeren',
      disabled: false,
    },
  ];

  return (
    <WizardLayout header="Realworks koppelen">
      <StepList
        currentStep={pathnameToStep(location.pathname, steps, 'setup')}
        steps={steps}
      />
      <DHRouter>
        <SetupStep
          path={'/'}
          onCancel={onClose}
          usedOffices={usedOffices}
          disableClosing
        />
        <ImportContactsStep
          path={'/import-contacts'}
          onCancel={onClose}
          disableClosing
        />
        <ImportAgendaStep
          path={'/import-agenda'}
          onCancel={onClose}
          disableClosing
        />
        {/* <ExportContactsStep
          path={'/export-contacts'}
          onCancel={onClose}
          disableClosing
        /> */}
        <ActivationPendingStep
          path="/activation-pending"
          onCancel={onClose}
          refreshAppStatus={refreshAppStatus}
          disableClosing
        />
      </DHRouter>
    </WizardLayout>
  );
};

export type StepProps = {
  onCancel?: () => void;
  disableClosing: boolean;
} & RouteComponentProps;

export default withOverlay<Props>(AddTokenContainerWizard);
